module.exports = __webpack_public_path__ + "img/pdf.67b5cdb1.png";